import React from 'react';
import './Projects.css';
import { dotIcon, circleIcon } from '../assets';
import { InfiniteMenu, FlowingMenu} from '../components';

const skillsList = [
  'ReactJS',
  'NodeJS',
  'Python',
  'ML/AL',
  'OpenCV',
  'Tensorflow',
  'PyTorch',
  'AWS',
  'Terraform',
  'Kubernetes',
  'Helm',
  'Rest API',
];

const items = [
  {
    image: 'https://picsum.photos/300/300?grayscale',
    title: 'This Website',
    description:
      'This is pretty cool, right?\n\n\
    ReactJS, CSS, ESLint, NodeJS, Github, Blood, Sweat and Tears.',
  },
  {
    image: 'https://picsum.photos/800/800?grayscale',
    title: 'Semantic RAG System',
    description:
      'RAG system yielding 95% accuracy on unseen docs, without LLM tuning\n\n\
    Llama 2.0, LangChain, FAISS, ChromaDB.',
  },
  {
    image: 'https://picsum.photos/400/400?grayscale',
    title: 'Intelligent 3D Mapping Robot',
    description:
      'Self driving robot with 95% 3D mapping accuracy.\n\n\
    ROS, SLAM, Jackal, Python, Docker',
  },
  {
    image: 'https://picsum.photos/700/700?grayscale',
    title: 'Tetris-AI',
    description:
      'Tetris game with AI autonomous play.\n\n\
    PyQT5, Python, NumPy, Tensorflow',
  },
  {
    image: 'https://picsum.photos/500/500?grayscale',
    title: 'Emotional Input',
    description:
      'Led an 8-member team to develop an emotion-tracking app.\n\n\
    Android Kotlin, ReactJS, Supabase, Git, JIRA',
  },
  {
    image: 'https://picsum.photos/600/600?grayscale',
    title: 'Chat-AI',
    description:
      'Conversational AI assistant with advanced speech and performance optimization.\n\n\
    AI, OpenAI, NLP, Speech Recognition, Text to Speech',
  },
  {
    image: 'https://picsum.photos/900/900?grayscale',
    title: 'The Sound Project',
    description:
      'Gamified image recognition tool to play instruments via hand gestures.\n\n\
    Python, OpenCV, Hidden Markov Models, MIDI',
  },
];

const Projects = () => {
  return (
    <section id="projects" className="projects-section">
      <div className="titletext">
        <img src={dotIcon} className="dot2" alt="dotimg"></img>
        <l3>FEATURED</l3>
        <l2bb>PROJECTS </l2bb>
        <img src={circleIcon} className="circleimg" alt="circleimg"></img>
      </div>
      <div className="divider"></div>

      <div style={{ height: '100vh', position: 'relative' }}>
        <InfiniteMenu items={items} />
      </div>
      <div className="divider-end"></div>
      <l4>SKILLS</l4>
      <div className="line"></div>
      <div style={{ height: '15vw', position: 'relative' }}>
        <FlowingMenu items={skillsList} />
      </div>
      <div className="line2"></div>
    </section>
  );
};

export default Projects;
